var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", disabled: !_vm.header.icon },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "span",
                _vm._g({}, on),
                [
                  !_vm.header.icon
                    ? [_vm._v(" " + _vm._s(_vm.header.text) + " ")]
                    : [
                        _c(
                          "v-icon",
                          {
                            staticStyle: { opacity: "unset" },
                            attrs: { size: "24", color: "primary" }
                          },
                          [_vm._v(_vm._s(_vm.header.icon))]
                        )
                      ]
                ],
                2
              )
            ]
          }
        }
      ])
    },
    [_c("span", [_vm._v(" " + _vm._s(_vm.header.text) + " ")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }